import type { FaireProductEntity } from "../../entity_types/product";

export const p_5y9aq5xw4n: FaireProductEntity = {
  token: "p_5y9aq5xw4n",
  type: "product",
  name: "Diva Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/fba8008cbeb5af17276e662dcbc21dde214c2314da73361ba7413976e8fcbc2b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25ae7cb065225345a6e30b1e84efdd2c126331be40e5dc5519a23a737a9ad37f.jpeg",
    "https://cdn.faire.com/fastly/8619ba528c61d3e24c65df51b2ad70201e83e3c8a90fbe50acef7ed53a514ce3.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/454ad209bc1960fe8bceb427b37e0892d61c0f19093eb3e34300a2783ca6de80.jpeg",
    "https://cdn.faire.com/fastly/f4c1c2320daa53ef3e6edce1aaecf3381a8e3d575e02ca05e1244108903dcf11.jpeg",
    "https://cdn.faire.com/fastly/454aa3c73b8aeb89e527cc3c47018a1587e9af45af103e8d3744e6c7a2047aa5.jpeg",
    "https://cdn.faire.com/fastly/7135f41355a03c711eee3f4f9c5b9514ebcc0071be50590802278ab14ff6f98f.jpeg",
    "https://cdn.faire.com/fastly/824f9de01f8ea72c895f0d627a2035799a4978b2522637ce8aa9ad0e7caba9c2.jpeg"
  ],
  priceDollars: 6.75,
  description: "Anyone can be a DIVA if you've got the swagger and tenacity (and these socks, obv) 💅\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:55.235Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
